// Environment helpers for dashboard behavior
// Relies on Vite's import.meta.env.MODE and optional VITE_ENVIRONMENT override.
// Define VITE_ENVIRONMENT in .env files (e.g., local, dev, stage, prod) for explicit control.

export type AppEnvironment = 'local' | 'dev' | 'stage' | 'prod' | 'unknown'

export function getEnvironment(): AppEnvironment {
  const explicit = (import.meta.env.VITE_ENVIRONMENT as string | undefined)?.trim().toLowerCase()
  if (explicit === 'local' || explicit === 'dev' || explicit === 'stage' || explicit === 'prod') return explicit
  // Fallback using mode heuristic
  const mode = import.meta.env.MODE
  if (mode === 'development') return 'local'
  if (mode === 'production') return 'prod'
  return 'unknown'
}

export function canUseMockData(): boolean {
  const env = getEnvironment()
  return env === 'local' || env === 'dev'
}

export function shouldSendMock(mockFlag: boolean | undefined): boolean {
  return !!mockFlag && canUseMockData()
}
